import { c as _c } from "react/compiler-runtime";
import { zIndices } from '@newfront-insurance/core-ui';
import { motion, AnimatePresence } from 'framer-motion';
import type { JSX } from 'react';
import { NotificationItem } from './notification-item';
import { useNotifications, useNotificationsOffset } from '../context';
export function NotificationList() {
  const $ = _c(9);
  const {
    entries: notifications
  } = useNotifications();
  const offsetX = useNotificationsOffset();
  let t0;
  if ($[0] !== offsetX) {
    t0 = {
      position: "fixed",
      zIndex: zIndices.notifications,
      bottom: 16,
      left: "50%",
      marginLeft: offsetX,
      transform: "translate(-50%, 0)"
    };
    $[0] = offsetX;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== notifications) {
    t1 = notifications.map(_temp);
    $[2] = notifications;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <AnimatePresence initial={false}>{t1}</AnimatePresence>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t2) {
    t3 = <div style={t0}>{t2}</div>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(notification) {
  return <motion.div key={notification.id} initial={{
    opacity: 0,
    y: 50,
    scale: 0.3
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} exit={{
    opacity: 0,
    scale: 0.5,
    transition: {
      duration: 0.2
    }
  }}><NotificationItem key={notification.id} id={notification.id} notification={notification.data} /></motion.div>;
}